import { render, staticRenderFns } from "./RewardPhone.vue?vue&type=template&id=3c303ffa&scoped=true"
import script from "./RewardPhone.vue?vue&type=script&lang=js"
export * from "./RewardPhone.vue?vue&type=script&lang=js"
import style0 from "./RewardPhone.vue?vue&type=style&index=0&id=3c303ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c303ffa",
  null
  
)

export default component.exports